import { createContext, useState } from "react";

export const CrudUserContext = createContext()

export function CrudUserProvider({ children, ...rest }) {
  const [inputCompany, setInputCompany] = useState()
  
  return (
    <CrudUserContext.Provider
      value={{
        inputCompany,
        setInputCompany
      }}
    >
      {children}
    </CrudUserContext.Provider>
  )
}